import { default as _91id_93ELMEunHgOyMeta } from "/app/pages/campaign/[id].vue?macro=true";
import { default as indexptpHsbADJwMeta } from "/app/pages/campaign/index.vue?macro=true";
import { default as newE4Edz8AqSKMeta } from "/app/pages/campaign/new.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as _91id_93r7DKvU3SvIMeta } from "/app/pages/public/customer/report/[id].vue?macro=true";
import { default as indexcYLHwCDNydMeta } from "/app/pages/reports/index.vue?macro=true";
import { default as _91id_93pAK8pLVUzgMeta } from "/app/pages/scodi/[id].vue?macro=true";
import { default as indexKNOweE1a1UMeta } from "/app/pages/scodi/index.vue?macro=true";
import { default as newj0G4ayR8mmMeta } from "/app/pages/scodi/new.vue?macro=true";
import { default as index500IpQXDKBMeta } from "/app/pages/transmission/index.vue?macro=true";
import { default as _91id_93RVBZU44zsvMeta } from "/app/pages/user/[id].vue?macro=true";
import { default as indexC5fV0gYHokMeta } from "/app/pages/user/index.vue?macro=true";
import { default as newYAvu1FpstaMeta } from "/app/pages/user/new.vue?macro=true";
export default [
  {
    name: "campaign-id",
    path: "/campaign/:id()",
    component: () => import("/app/pages/campaign/[id].vue").then(m => m.default || m)
  },
  {
    name: "campaign",
    path: "/campaign",
    component: () => import("/app/pages/campaign/index.vue").then(m => m.default || m)
  },
  {
    name: "campaign-new",
    path: "/campaign/new",
    component: () => import("/app/pages/campaign/new.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "public-customer-report-id",
    path: "/public/customer/report/:id()",
    component: () => import("/app/pages/public/customer/report/[id].vue").then(m => m.default || m)
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/app/pages/reports/index.vue").then(m => m.default || m)
  },
  {
    name: "scodi-id",
    path: "/scodi/:id()",
    component: () => import("/app/pages/scodi/[id].vue").then(m => m.default || m)
  },
  {
    name: "scodi",
    path: "/scodi",
    component: () => import("/app/pages/scodi/index.vue").then(m => m.default || m)
  },
  {
    name: "scodi-new",
    path: "/scodi/new",
    component: () => import("/app/pages/scodi/new.vue").then(m => m.default || m)
  },
  {
    name: "transmission",
    path: "/transmission",
    component: () => import("/app/pages/transmission/index.vue").then(m => m.default || m)
  },
  {
    name: "user-id",
    path: "/user/:id()",
    component: () => import("/app/pages/user/[id].vue").then(m => m.default || m)
  },
  {
    name: "user",
    path: "/user",
    component: () => import("/app/pages/user/index.vue").then(m => m.default || m)
  },
  {
    name: "user-new",
    path: "/user/new",
    component: () => import("/app/pages/user/new.vue").then(m => m.default || m)
  }
]